/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-09-20 11:03:46
 * @version 1.0.0
 */

import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router';

import { HOME_NAV_KEY } from '@src/utils/constant/common';
import { NAVIGATOR_MAP } from '@src/utils/constant/home';
import { classnames, getPathGroup } from '@src/utils';

import { NavigatorItem } from '@src/types';

import './SFCNavigator.less';

type Props = RouteComponentProps;

export const SFCNavigator: React.SFC<Props> = (props: Props) => {
  const {
    location: { pathname }
  } = props;

  let navKey = getPathGroup({
    str: pathname,
    reg: new RegExp(`/${HOME_NAV_KEY}/([a-z]+)/`),
    defaultGroup: ''
  });

  if (pathname === '/') {
    navKey = NAVIGATOR_MAP.defaultActiveKey;
  }

  const onClick = (item: NavigatorItem) => {
    if (item.path && pathname !== item.path) {
      props.history.push(item.path);
    }
  };

  return (
    <ul className="k-tech-com-navigator">
      {NAVIGATOR_MAP.data.map((item: NavigatorItem, index: number) => (
        <li
          className={classnames('k-tech-cursor-pointer', 'item', {
            'active-item': item.key === navKey
          })}
          key={index}
          onClick={() => onClick(item)}
        >
          {item.title}
        </li>
      ))}
    </ul>
  );
};

export default withRouter(SFCNavigator);
